export enum Ciasteczko {
    DaneZalogowanegoUzytkownika = "ZDXVNJ"
}